/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CriteriaTargetGroup } from './CriteriaTargetGroup';
import {
    CriteriaTargetGroupFromJSON,
    CriteriaTargetGroupFromJSONTyped,
    CriteriaTargetGroupToJSON,
} from './CriteriaTargetGroup';

/**
 * 
 * @export
 * @interface FindAllCriteriaTargets200Response
 */
export interface FindAllCriteriaTargets200Response {
    /**
     * 
     * @type {Array<CriteriaTargetGroup>}
     * @memberof FindAllCriteriaTargets200Response
     */
    data?: Array<CriteriaTargetGroup>;
}

/**
 * Check if a given object implements the FindAllCriteriaTargets200Response interface.
 */
export function instanceOfFindAllCriteriaTargets200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllCriteriaTargets200ResponseFromJSON(json: any): FindAllCriteriaTargets200Response {
    return FindAllCriteriaTargets200ResponseFromJSONTyped(json, false);
}

export function FindAllCriteriaTargets200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCriteriaTargets200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(CriteriaTargetGroupFromJSON)),
    };
}

export function FindAllCriteriaTargets200ResponseToJSON(value?: FindAllCriteriaTargets200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(CriteriaTargetGroupToJSON)),
    };
}

